// extracted by mini-css-extract-plugin
export default {"emailFormatDesc":"K3voe"};